export default __webpack_public_path__ + "static/media/Jenkins.92acf57f.jpeg";